import { provide } from "vue";

export function useResourceShare(
	listUsers,
	grantPermission,
	removePermission,
	listRoles?,
	grantRolePermission?,
	removeRolePermission?
): void {
	provide("listUsersWithPermissions", listUsers);
	provide("grantPermissionAction", grantPermission);
	provide("removePermissionAction", removePermission);
	provide("listRolesWithPermissions", listRoles);
	provide("grantRolePermissionAction", grantRolePermission);
	provide("removeRolePermissionAction", removeRolePermission);
}
